import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init
const config = {
  apiKey: "AIzaSyA1CKaMtyiywbOkNSF-I3TOATxY-Capfug",
  authDomain: "ccs-online-prototype.firebaseapp.com",
  databaseURL: "https://ccs-online-prototype.firebaseio.com",
  projectId: "ccs-online-prototype",
  storageBucket: "ccs-online-prototype.appspot.com",
  messagingSenderId: "883451292502",
  appId: "1:883451292502:web:2061fa7fcdccd61d2d44f7"
}
firebase.initializeApp(config)

// firebase.getCurrentUser = () => {
//   return new Promise((resolve, reject) => {
//     const unsubscribe = firebase.auth().onAuthStateChanged(user => {
//       unsubscribe()
//       resolve(user)
//     }, reject)
//   })
// }

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const fieldValue = firebase.firestore.FieldValue
// const storage = firebase.storage()

// date issue fix no longer needed according to firebase
// const settings = {
//   timestampsInSnapshots: true
// }
// db.settings(settings)

// firebase storage refs
// const storageRef = storage.ref()

const batch = db.batch()

// firebase collections
const usersCollection = db.collection('users')
const districtsCollection = db.collection('districts')
const testDistrictsCollection = db.collection('testDistricts')
const unitsCollection = db.collection('units')
const userCodesCollection = db.collection('userCodes')
const districtCodesCollection = db.collection('districtCodes')
const trainingSessionsCollection = db.collection('trainingSessions')
const trainingSessionsCollectionNew = db.collection('trainingSessionsNew')
const trainingRegistrationsCollection = db.collection('trainingRegistrations')

export {
    db,
    auth,
    currentUser,
    fieldValue,
    usersCollection,
    districtsCollection,
    testDistrictsCollection,
    unitsCollection,
    userCodesCollection,
    districtCodesCollection,
    trainingSessionsCollection,
    trainingSessionsCollectionNew,
    trainingRegistrationsCollection,
    batch
    // storageRef,
    // storage
}
